import { State } from '@/views/changelog-settings/changelog-settings.types';

const mutations = {
  setSettingsLoading(state: State, payload: boolean) {
    state.settingsLoading = payload;
  },
  setSystemChangelogSettings(state: State, payload: boolean) {
    state.systemAutoAccept = payload;
  },
  setUserChangelogSettings(state: State, payload: boolean) {
    state.userAutoAccept = payload;
  },
};

export default mutations;
